import Message from '@/utils/message'
import RealGrid from 'realgrid/dist/main'

let RealgridFactory = function(gridRef, cfg) {
  let gridView
  let dataProvider
  let type = cfg.type || 'grid'
  let isRowTx = cfg.isRowTx || false
  let fields = cfg.fields
  let columns = cfg.columns
  let options = cfg.options
  let headercheckLocation = false // 헤더 체크박스
  let saveDataCnt = 0

  let colDynamicStyles = cfg.colDynamicStyles || true

  // 기본(병합) 옵션 - 그리드
  let addGridOptions = {
    edit: {
      editable: false,
      appendable: false,
      insertable: false,
      updatable: false,
      deletable: false
    },
    paste: {
      forceRowValidation: true,
      forceColumnValidation: true
    },
    sorting: {},
    filtering: {},
    checkBar: {},
    stateBar: {
      // visible: false
    },
    panel: {
      visible: false
    },
    footers: {
      visible: false
    },
    display: {
      // 그리드 너비에 맞춰 컬럼 너비 자동 조정
      fitStyle: 'even'
    }
  }
  // 기본(병합) 옵션 - dataProvider
  let addDataProviderOptions = {
    restoreMode: 'auto',
    // Client is editing 메시지(그리드 편집 시 저장되지 않은 상태에서 다른 행의 값을 변경하는 동작을 실행할 때 발생하는 경고창) 강제 commit
    commitBeforeDataEdit: true,
    softDeleting: true,
    deleteCreated: true
  }
  let contextMenuArray = [
    { label: 'Column Filter 켜키', type: 'normal', tag: 'filter_on' },
    { label: 'Column Filter 끄기', type: 'normal', tag: 'filter_off' },
    { label: '-' }, // 메뉴 구분선 추가
    { label: 'Excel Export', type: 'normal', tag: 'export' }
  ]

  let inited = false

  let appendField = [
    { fieldName: 'ret_code', dataType: 'string' },
    { fieldName: 'ret_msg', dataType: 'string' },
    { fieldName: 'recv_status', dataType: 'string' }
  ]

  let _getConcatFields = (fd, apdfd) => {
    if (isRowTx) {
      let inFields = []
      let outFields = []
      apdfd.forEach(item => {
        if (fields.some(f => f.fieldName === item.fieldName)) {
          outFields.push(item)
        } else {
          inFields.push(item)
        }
      })
      return fd.concat(inFields)
    } else {
      return fd
    }
  }

  let _createGrid = () => {
    if (type === 'grid') {
      dataProvider = new RealGrid.LocalDataProvider()
      gridView = new RealGrid.GridView(gridRef)
    } else {
      dataProvider = new RealGrid.LocalTreeDataProvider()
      gridView = new RealGrid.TreeView(gridRef)
    }
    gridView.setDataSource(dataProvider)
  }
  let _initialiseGrid = () => {
    // 추가 필드 값 정의하여 넣는다.
    dataProvider.setFields(_getConcatFields(fields, appendField))

    gridView.setColumns(columns)
    inited = true

    gridView.onValidationFail = function(grid, itemIndex, column, err) {
      Message.err(err.message)
    }
  }

  let _setGridOptions = () => {
    // [gridView options]
    if (options && options.gridView) {
      Object.assign(addGridOptions, options.gridView)
    }
    gridView.setOptions(addGridOptions)

    // [dataProvider options]
    if (options && options.dataProvider) {
      Object.assign(addDataProviderOptions, options.dataProvider)
    }
    dataProvider.setOptions(addDataProviderOptions)

    // 필터 옵션 설정
    gridView.setFilteringOptions({
      selector: {
        showButtons: true, // 버튼 표시 여부
        acceptText: '확인', // 필터 적용 버튼 text
        cancelText: '취소' //  취소 버튼 text
      }
    })
  }

  let _setColumnInfos = () => {
    columns.forEach(col => {
      // header 영역 중 require 옵션이 있는 경우, 컬럼 해더 텍스트에 * 입력
      if (col.header && col.header.require) {
        // realgrid 2.0 마이그레이션 작업 변경 후
        col.header.text = '* ' + col.header.text
        // 필수 값 처리
        if (!col.validations) col.validations = []
        var compiled = _.template('${header}은(는) 반드시 입력해야 합니다.')
        col.validations = col.validations.concat([
          {
            criteria: 'value is not empty',
            message: compiled({ header: col.header.text }),
            mode: 'always',
            level: 'error'
          }
        ])
      }
    })
  }
  let _setDynamicStyles = () => {
    columns.forEach(col => {
      // realgrid 2.0 마이그레이션 작업 후
      col.styleCallback = function(grid, dataCell) {
        let column = dataCell.index.column
        let provider = grid.getDataSource()
        let ret = {}
        if (column.editable === true) {
          ret.styleName = column.styleName ? column.styleName + ' editable_column' : 'editable_column'
        }

        let row = provider.getJsonRow(dataCell.index.dataRow)
        let status = row.recv_status
        let isChange = row.is_change
        let gridRowStatus = provider.getRowState(dataCell.index.dataRow)
        if (status === 'error' && isChange === 'Y') {
          ret.styleName = column.styleName ? column.styleName + ' created_column' : 'created_column'
        } else if (status === 'error' && isChange === 'Y') {
          ret.styleName = column.styleName ? column.styleName + ' updated_column' : 'updated_column'
        } else if (status === 'error') {
          ret.styleName = column.styleName ? column.styleName + ' error_column' : 'error_column'
        } else if (gridRowStatus === 'created') {
          ret.styleName = column.styleName ? column.styleName + ' created_column' : 'created_column'
        } else if (gridRowStatus === 'updated') {
          ret.styleName = column.styleName ? column.styleName + ' updated_column' : 'updated_column'
        }
        //  else if (status === 'success') {
        //   ret.background = colors.background.success
        // }
        return ret
      }
    })
  }

  let _setEvents = () => {
    // onColumnCheckedChanged
    if (headercheckLocation) {
      gridView.onColumnCheckedChanged = (cgrid, column, checked) => {
        let dataField = dataProvider.fieldByName(column.name)
        let rowCount = dataProvider.getRowCount()

        if (dataField) {
          let fieldDatatype = dataField.dataType
          cgrid.commit()

          dataProvider.beginUpdate()
          try {
            if (fieldDatatype === 'text') {
              for (let i = 0; i < rowCount; i++) {
                dataProvider.setValue(i, column.fieldName, checked ? 'Y' : 'N')
              }
            } else {
              for (let i = 0; i < rowCount; i++) {
                dataProvider.setValue(i, column.fieldName, checked)
              }
            }
          } finally {
            dataProvider.endUpdate()
          }
        }
      }
    }

    // tree events
    if (type === 'tree') {
      // onItemChecked
      gridView.onItemChecked = (cgrid, itemIndex, checked) => {
        // 체크된 row의 모든 자식 노드들을 체크해준다. 자식 row들에 대해 itemcheck 시 호출되는 callback 함수 실행되지 않음
        gridView.checkChildren(itemIndex, checked, true, false, true, false)
        // 체크된 row의 모든 부모 노드들의 itemIndex 값을 가져온다
        let parentRowItemIndexs = gridView.getAncestors(itemIndex, false)
        parentRowItemIndexs.forEach(pItemIndex => {
          // itemIndex 를 넣어 dataRow 값을 가져온다. (데이터를 가져오기 위해서 필요한 값)
          var dataRow = gridView.getDataRow(pItemIndex)
          if (dataRow > 0) {
            // 모든 부모 아이디를 가져오면 rootNode(dataRow -1임) 까지 가져와서 해당 로우는 걸러지게한다.
            // 부모 row 들을 체크 또는 체크 해제 해준다. 부모 row 들에 대해 itemcheck 시 호출되는 callback 함수 실행되지 않음
            if (gridView.isCheckable(pItemIndex)) {
              // 자식 checked
              let childrenRowItemIndexs = gridView.getChildren(pItemIndex)
              let parentChecked = false
              let childrenCheckRowCount = 0
              childrenRowItemIndexs.forEach(cItemIndex => {
                if (gridView.isCheckedItem(cItemIndex)) {
                  // parentChecked = true
                  childrenCheckRowCount++
                }
              })
              if (childrenRowItemIndexs.length === childrenCheckRowCount) {
                parentChecked = true
              }
              // gridView.checkItem(pItemIndex, checked, false, false)
              gridView.checkItem(pItemIndex, parentChecked, false, false)
            } else {
              gridView.checkItem(pItemIndex, false, false, false)
            }
          }
        })
      }
    } else if (type === 'reverseCheckTree') {
      // onItemChecked
      gridView.onItemChecked = (cgrid, itemIndex, checked) => {
        // 체크된 row의 모든 자식 노드들을 체크해준다. 자식 row들에 대해 itemcheck 시 호출되는 callback 함수 실행되지 않음
        gridView.checkChildren(itemIndex, checked, true, false, true, false)
        // 체크된 row의 모든 부모 노드들의 itemIndex 값을 가져온다
        let parentRowItemIndexs = gridView.getAncestors(itemIndex)
        parentRowItemIndexs.forEach(pItemIndex => {
          // itemIndex 를 넣어 dataRow 값을 가져온다. (데이터를 가져오기 위해서 필요한 값)
          var dataRow = gridView.getDataRow(pItemIndex)
          if (dataRow > 0) {
            // 모든 부모 아이디를 가져오면 rootNode(dataRow -1임) 까지 가져와서 해당 로우는 걸러지게한다.
            // 부모 row 들을 체크 또는 체크 해제 해준다. 부모 row 들에 대해 itemcheck 시 호출되는 callback 함수 실행되지 않음
            if (gridView.isCheckable(pItemIndex)) {
              // 자식 checked
              let childrenRowItemIndexs = gridView.getChildren(pItemIndex)
              let parentChecked = false
              childrenRowItemIndexs.forEach(cItemIndex => {
                if (gridView.isCheckedItem(cItemIndex)) {
                  parentChecked = true
                }
              })
              // gridView.checkItem(pItemIndex, checked, false, false)
              gridView.checkItem(pItemIndex, parentChecked, false, false)
            } else {
              gridView.checkItem(pItemIndex, false, false, false)
            }
          }
        })
      }
    }
  }

  let _setContextMenu = () => {
    gridView.setContextMenu(contextMenuArray) // 컨텍스트 메뉴 설정
    // 컨텍스트 메뉴가 실행될 때 호출되는 함수, false 를 리턴하면 컨텍스트 메뉴를 실행하지 않는다.
    gridView.onContextMenuPopup = (cgrid, x, y, elementName) => {
      // 조회 전이거나, 조회후에 그리드 데이터가 없으면 컨텍스트 메뉴 실행하지 않음
      if (!inited || dataProvider.getRowCount() <= 0) return false
      // 헤더, 푸터, 그룹핑 패널 영역에서는 컨텍스트 메뉴 실행하지 않음
      if (elementName !== ('GridBody' && 'DataCell')) return false
    }

    gridView.onContextMenuItemClicked = (cgrid, menuItem, index) => {
      // 선택된 contextmenu 항목에 따라 처리
      switch (menuItem.tag) {
        case 'export': // 엑셀 다운로드
          gridView.exportGrid({
            type: 'excel',
            target: 'local',
            fileName: 'gridExport.xlsx', // 저장될 파일 name
            progressMessage: '엑셀 다운로드중입니다.', // 엑셀 다운로드 하는 동안 progressMessage 표시
            showProgress: true, // 엑셀 다운로드 하는 동안 progressBar 표시
            indicator: 'visible', // indidator 영역 표시
            header: 'visible', // 헤더 표시
            footer: 'hidden', // footer 표시하지 않음
            done: () => {
              // 내보내기 완료 후 실행되는 함수
              Message.success('엑셀 다운로드가 완료되었습니다.')
            }
          })
          break
        case 'filter_on': // Column Filter 켜키
          var distinctValues = dataProvider.getDistinctValues(index.column) // 지정된 컬럼의 데이터들을 중복을 제거하고 가져온다.
          var filters = []
          for (var value of distinctValues) {
            // 중복을 제거한 데이터를 넣어준다.
            // name: 사용자에게 보여질 값
            // criteria: 해당 필터 선택시 필터 조건
            filters.push({ name: value, criteria: "value = '" + value + "'" })
          }
          gridView.setColumnFilters(index.column, filters) // 선택된 컬럼에 필터 셋팅
          break
        case 'filter_off': // Column Filter 끄기
          gridView.clearColumnFilters(index.column) // 해당 컬럼의 필터 설정을 해제한다
          break
      }
    }
  }

  // 저장을 위하여 created, updated, deleted 각각 상태의 row를 가져와 반영 한다.
  let _getSaveData = saveDitc => {
    if (!_commit()) return

    var gridSaveData = {
      updated: [],
      created: [],
      deleted: []
    }
    saveDataCnt = 0
    // 각 상태 별 값을 가져온다.
    if (!saveDitc || saveDitc.indexOf('u') !== -1) {
      var updatedRows = dataProvider.getStateRows('updated')
      updatedRows.forEach((row, idx) => {
        let u = dataProvider.getJsonRow(row)
        u.dataRow = row
        gridSaveData.updated.push(u)
      })
      saveDataCnt += gridSaveData.updated.length
    }

    if (!saveDitc || saveDitc.indexOf('c') !== -1) {
      var createdRows = dataProvider.getStateRows('created')
      createdRows.forEach((row, idx) => {
        let c = dataProvider.getJsonRow(row)
        c.dataRow = row
        gridSaveData.created.push(c)
      })
      saveDataCnt += gridSaveData.created.length
    }

    if (!saveDitc || saveDitc.indexOf('d') !== -1) {
      var deletedRows = dataProvider.getStateRows('deleted')
      deletedRows.forEach((row, idx) => {
        let d = dataProvider.getJsonRow(row)
        d.dataRow = row
        gridSaveData.deleted.push(d)
      })
      saveDataCnt += gridSaveData.deleted.length
    }
    console.log('saveDataCnt:' + saveDataCnt)

    return gridSaveData
  }

  let _getCheckedRows = isMessageCheck => {
    if (!_commit()) return

    let rows = gridView.getCheckedRows(true)

    if (isMessageCheck && rows.length < 1) {
      Message.warn('선택된 항목이 없습니다.')
      return null
    }
    return rows
  }

  let _commit = () => {
    if (gridView.isItemEditing()) {
      try {
        gridView.commit()
      } catch (e) {
        Message.err(e.message)
        return false
      }
    }
    return true
  }

  let _doActions = params => {
    let actionApi = params.api
    let actionType = params.actionType
    let resolve = params.resolve
    let reject = params.reject
    let finalFun = params.finally
    let addParam = params.addParam
    let apiParam

    if (!_commit()) return

    if (actionType === 'doSave') {
      apiParam = _getSaveData('cu')
    } else if (actionType === 'doDelete') {
      apiParam = _getSaveData('d')
    } else {
      apiParam = _getSaveData()
    }

    if (addParam) {
      for (let key in addParam) {
        apiParam[key] = addParam[key]
      }
    }
    console.log('apiParam :>> ', apiParam)

    if (saveDataCnt < 1 && actionType !== 'doDelete') {
      Message.warn('저장할 대상이 없습니다.')
      return
    } else if (saveDataCnt < 1 && actionType === 'doDelete') {
      if (resolve) resolve()
      return
    }

    if (typeof actionApi !== 'function') {
      Message.err(
        '잘못된 파라미터 설정입니다. api 매개변수를 함수로 수정바랍니다.'
      )
      return
    }

    return actionApi(apiParam)
      .then(res => {
        if (resolve) resolve()

        // RowTx 인 경우 결과처리
        _setRowTxResult()
      })
      .catch(error => {
        if (reject) {
          reject()
        } else {
          Message.err(error)
        }
      })
      .then(() => {
        if (finalFun) finalFun()
      })
  }

  // RowTx 적용된 그리드 상태처리
  let _setRowTxResult = () => {
    if (!isRowTx) return

    let rows = dataProvider.getJsonRows(0, -1)
    if (rows) {
      rows.forEach(row => {
        if (row.ret_code === 'Y') {
          row.recv_status = 'success'
          dataProvider.setRowState(row.dataRow, 'none')
        } else {
          row.recv_status = 'error'
        }
      })
    }
  }

  // 트리를 반환한다.
  let _setTreeData = treeData => {
    var tree = {}
    tree[options.tree.childCol] = []

    treeData.forEach(treeItem => {
      _resolveTreeData(treeItem, tree, tree) // 함수에 각 데이터를 넣어 트리를 만든다.
    })
    return tree[options.tree.childCol]
  }

  let _resolveTreeData = (treeItem, targetTreeItem, tree) => {
    if ((treeItem[options.tree.levelCol] | 0) === 1) {
      tree[options.tree.childCol].push(treeItem)
      return
    }

    if (
      treeItem[options.tree.prntIdCol] === targetTreeItem[options.tree.idCol]
    ) {
      if (!targetTreeItem[options.tree.childCol]) {
        targetTreeItem[options.tree.childCol] = []
      }
      targetTreeItem[options.tree.childCol].push(treeItem)
      return
    }
    if (targetTreeItem[options.tree.childCol]) {
      targetTreeItem[options.tree.childCol].forEach(newTargetTreeItem => {
        _resolveTreeData(treeItem, newTargetTreeItem, tree)
      })
    }
  }

  let _initRow = row => {
    if (!isRowTx) return
    row.ret_code = ''
    row.ret_msg = ''
    row.recv_status = ''
  }

  let _insertRow = (targetRow, iRow) => {
    if (!_commit()) return

    if (!targetRow) targetRow = 0
    _initRow(iRow)
    // 타겟 위치에 값 넣기
    dataProvider.insertRow(targetRow, iRow)
    // 이동할 위치 설정
    let idx = {
      column: 0,
      dataRow: targetRow
    }
    // 이동
    gridView.setCurrent(idx)
  }

  let _addChildRow = (parentRow, iRow) => {
    if (parentRow) {
      _insertChildRow(parentRow, iRow)
    } else {
      _addRootRow(iRow)
    }
  }
  let _insertChildRow = (parentRow, iRow) => {
    if (!_commit()) return

    let cRowValues = iRow || []
    // 해당 셀의 자식 노드 수를 가져온다.
    var childCount = dataProvider.getChildCount(parentRow.dataRow)
    // 자식의 가장 마지막 위치에 row 를 추가한다.
    var addRowIdx = dataProvider.insertChildRow(
      parentRow.dataRow,
      childCount,
      cRowValues
    )
    // 자식 노드 추가시 부모 노드의 트리 펼침
    gridView.expand(parentRow.itemIndex)

    // 추가된 노드에 포커스 맞춤
    gridView.setCurrent({
      itemIndex: gridView.getItemIndex(addRowIdx)
    })
  }

  // 최상위 노드 추가
  let _addRootRow = iRow => {
    if (!_commit()) return

    let cRowValues = iRow || []
    var addRowIdx = dataProvider.addChildRow(0, cRowValues)

    // 추가된 노드에 포커스 맞춤
    gridView.setCurrent({
      itemIndex: gridView.getItemIndex(addRowIdx)
    })
  }

  let _fillJsonData = res => {
    if (!_commit()) return
    dataProvider.clearRows()

    if (type === 'grid') {
      if (res.dataList !== undefined) {
        dataProvider.fillJsonData(res.dataList)
      } else {
        dataProvider.fillJsonData(res)
      }
    } else {
      let treeRes = []
      if (res) {
        treeRes[options.tree.childCol] = _setTreeData(res)
      }
      // RealGrid에 조회한 데이터를 넣는다.
      dataProvider.fillJsonData(treeRes, { rows: options.tree.childCol })
    }
  }

  // 객체 생성
  _createGrid()
  // Option 설정
  _setGridOptions()
  if (colDynamicStyles) _setDynamicStyles()

  // Column 정보
  _setColumnInfos()
  // 초기화
  _initialiseGrid()

  // 이벤트
  _setEvents()

  // ContextMenu
  _setContextMenu()

  return {
    getGridView() {
      return gridView
    },
    getTreeView() {
      return gridView
    },
    getDataProvider() {
      return dataProvider
    },
    g() {
      return gridView
    },
    t() {
      return gridView
    },
    d() {
      return dataProvider
    },
    doSearch(params) {
      let retrieveApi = params.api
      let apiParam = params.apiParam
      let resolve = params.resolve
      let reject = params.reject
      let finalFun = params.finally

      if (typeof retrieveApi !== 'function') {
        Message.err(
          '잘못된 파라미터 설정입니다. api 매개변수를 함수로 수정바랍니다.'
        )
        return
      }

      return retrieveApi(apiParam)
        .then(res => {
          _fillJsonData(res)
          if (resolve) resolve()
        })
        .catch(error => {
          if (reject) {
            reject()
          } else {
            Message.err(error)
          }
        })
        .then(() => {
          if (finalFun) finalFun()
        })
    },
    loadSearchData(res) {
      if (typeof res !== 'object') {
        Message.err('잘못된 파라미터 설정입니다.')
        return
      }
      _fillJsonData(res)
    },
    deleteSelection() {
      // 옵션이 true일 경우 묻지않고 삭제 대상이 된다.
      gridView.deleteSelection(true)
    },
    doSaveAll(params) {
      params.actionType = 'doSaveAll'

      return _doActions(params)
    },
    doSave(params) {
      params.actionType = 'doSave'

      return _doActions(params)
    },
    doDelete(params) {
      params.actionType = 'doDelete'

      let removeRows = _getCheckedRows(true)
      let cf = params.confirm
      if (removeRows) {
        if (cf) {
          if (confirm(params.confirmOpt.msg)) {
            // dataProvider.removeRows(removeRows, false)
            dataProvider.setRowStates(removeRows, 'deleted')
            return _doActions(params)
          }
        } else {
          dataProvider.removeRows(removeRows, false)
          return _doActions(params)
        }
      }
    },
    getCheckedRows() {
      return _getCheckedRows(true)
    },
    resetColumns(_fields, _columns) {
      // 추가 필드 값 정의하여 넣는다.
      dataProvider.setFields(_getConcatFields(_fields, appendField))
      gridView.setColumns(_columns)
    },
    insertRow(targetRow, iRow) {
      _insertRow(targetRow, iRow)
    },
    // 행추가
    addRow(iRow) {
      // 선택된 셀 정보를 가져온다.
      var current = gridView.getCurrent()

      if (type === 'grid') {
        if (current.itemIndex < 0) {
          _insertRow(0, iRow)
        } else {
          _insertRow(current.dataRow, iRow)
        }
      } else {
        _addChildRow(current, iRow)
      }
    },
    addChildRow(parentRow, iRow) {
      _addChildRow(parentRow, iRow)
    },
    getAllData() {
      return dataProvider.getJsonRows(0, -1)
    },
    initRow(row) {
      _initRow(row)
    },
    // targetRow위치에 선택된 행의 내용을 복사하여 추가한다.
    copyAndInsertRow(targetRow) {
      if (!targetRow) targetRow = 0
      // 현재 위치 정보 확인
      let currnetTarget = gridView.getCurrent()
      // 데이터 값 가져오기
      let currentJsonRow = _.cloneDeep(
        dataProvider.getJsonRow(currnetTarget.dataRow)
      )
      _initRow(currentJsonRow)
      // 타겟 위치에 값 넣기
      dataProvider.insertRow(targetRow, currentJsonRow)
      // 이동할 위치 설정
      let idx = {
        column: currnetTarget.column,
        dataRow: targetRow
      }
      // 이동
      gridView.setCurrent(idx)
    },
    // checkbox에 체크된 항목들을 가져와 삭제 상태로 변경한다.
    deletCheckRow() {
      gridView.commit()
      let rows = gridView.getCheckedRows(true)
      for (let i = 0; i < rows.length; i++) {
        dataProvider.setRowState(rows[i], 'deleted')
        // 체크 내역을 다시 해제한다.
        gridView.checkAll(false)
      }
    },
    fillByJson(data, isCreated) {
      // 덮어씌우기 전에는 기존 진행 작업들은 cancel 처리 한다.
      gridView.cancel()
      dataProvider.fillJsonData(data)
      if (isCreated) {
        this.setAllRowState('created')
      }
    },
    fillByCsv(data, isCreated) {
      // 덮어씌우기 전에는 기존 진행 작업들은 cancel 처리 한다.
      gridView.cancel()
      dataProvider.fillCsvData(data)
      if (isCreated) {
        this.setAllRowState('created')
      }
    },
    getCurrent() {
      return gridView.getCurrent()
    },
    getCurrentDataRow() {
      let currnetTarget = gridView.getCurrent()
      if (currnetTarget.dataRow === -1) return {}
      return dataProvider.getJsonRow(currnetTarget.dataRow)
    },
    getDataForSave() {
      return _getSaveData()
    },
    getCreatedUpdatedData() {
      return _getSaveData('cu')
    },
    getDeleteData() {
      return _getSaveData('d')
    },
    setAllRowState(state) {
      gridView.commit()
      let count = dataProvider.getRowCount()
      for (let i = 0; i < count; i++) {
        dataProvider.setRowState(i, state)
      }
    },
    eventSetter(e, func) {
      gridView[e] = func
    },
    gInvoke(func, ...params) {
      return gridView[func](...params)
    },
    dInvoke(func, ...params) {
      return dataProvider[func](...params)
    },
    destroy() {
      // 데이터 초기화
      dataProvider.clearRows()

      // grid, provider 초기화
      gridView.destroy()
      dataProvider.destroy()

      // LocalDataProvider와 GridView 객체 초기화
      gridView = null
      dataProvider = null
    }
  }
}

export default RealgridFactory
